import { Form, FormField, FormFieldConditions, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { UserModel } from 'src/app/models/usuarios/user.model';


export class UsuariosListModalFormDefinition {
  public readonly formFields: Form<UserModel>;
  public readonly model: Partial<UserModel>;

  constructor(type: FormType, model: Partial<UserModel>, private readonly context: any = {}) {
    this.model = model;
    this.formFields = {
      name: 'usuarios-list-modal',
      header: 'Datos del usuario',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<UserModel>[] {
    const fields = this.context.canRegister
      ? [
        this.textField('username', 'Nombre de Usuario', 1, true, 4),
        this.textField('tipo', 'Tipo', 2, true, 4),
        this.textField('acceso_plataforma', 'Acceso a Plataforma', 3, true, 4),
        this.textField('nombre', 'Nombre', 4, true, 4),
        this.textField('apellidos', 'Apellidos', 5, true, 4),
        this.textField('nif', 'NIF / CIF', 6, true, 4),
        this.textField('email', 'Email', 7, true, 4),
        this.textField('telefono', 'Teléfono', 8, true, 4),
      ]
      : [
        this.textField('email', 'Email', 1, true, 4),
        this.textField('nombre', 'Nombre', 2, true, 4),
        this.textField('apellidos', 'Apellidos', 3, true, 4),
        this.textField('tipo_carnet', 'Tipo de carnet', 4, true, 4),
        this.textField('fecha_caducidad', 'Fecha de caducidad', 5, true, 4),
        this.textField('nif', 'NIF', 6, true, 4),
        this.textField('ropo', 'ROPO', 7, true, 4),
        this.textField('uds_medida', 'Unidad de medida', 8, Boolean(this.context.showPerfilUnidades), 4),
        this.textField('ratio_ha', 'Relación con una hectárea', 9, Boolean(this.context.showPerfilUnidades), 4),
        this.textField('tipo_mando', 'Tipo de mando', 10, this.context.appName === 'manezylozano', 4),
        this.textField('imei', 'IMEI', 11, this.context.appName === 'manezylozano', 4),
        this.textField('pais', 'País', 12, this.context.appName === 'manezylozano', 4),
      ];

    return [
      { name: '', fields, width: 12, isVisible: true, order: 1 },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<UserModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
